import { render } from "./routeVueComponent.vue?vue&type=template&id=05dafcde"
import script from "./routeVueComponent.vue?vue&type=script&lang=js"
export * from "./routeVueComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__